import { Link } from "react-router-dom";
import { latestManhwa } from "@/mocks/manhwa";

export default function LatestSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-600">紧跟韩漫最新动态，不错过每一话</p>
          </div>
          <Link
            to="/category/fantasy"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" data-product-shop>
          {latestManhwa.map((manhwa) => (
            <Link
              key={manhwa.id}
              to={`/article/${manhwa.id}`}
              className="group flex gap-4 bg-background-100 rounded-lg p-4 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-20 sm:w-24 flex-shrink-0">
                <div className="relative w-full aspect-[3/4] rounded-md overflow-hidden bg-background-200">
                  <img
                    src={manhwa.cover}
                    alt={manhwa.title}
                    title={`${manhwa.title} - 免费韩漫在线漫画`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                    {manhwa.title}
                  </h3>
                  <p className="text-xs text-foreground-500">{manhwa.author}</p>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500"></i>
                    </div>
                    {manhwa.rating}
                  </span>
                  <span>{manhwa.chapters}话</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}